/**
 * Help Search Bar Component
 *
 * Purpose: Search input for help articles in the side sheet
 * Created: March 24, 2026
 */

import React, { useState, useCallback } from 'react';
import { Search, X } from 'lucide-react';
import { Input } from '@xanectech/ui/components';

interface HelpSearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
}

export const HelpSearchBar: React.FC<HelpSearchBarProps> = ({
  onSearch,
  placeholder = 'Search help articles...',
}) => {
  const [value, setValue] = useState('');

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      setValue(newValue);
      onSearch(newValue);
    },
    [onSearch]
  );

  const handleClear = useCallback(() => {
    setValue('');
    onSearch('');
  }, [onSearch]);

  return (
    <div className='relative'>
      <Search
        size={14}
        className='absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground'
      />
      <Input
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className='pl-9 pr-8 h-9 text-sm'
      />
      {value && (
        <button
          onClick={handleClear}
          className='absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground'
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
};
